import script from "./AdminSupportIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminSupportIndex.vue?vue&type=script&setup=true&lang=js"

import "@/assets/styles/sfc/components/sites/AdminSupportIndex.css?vue&type=style&index=0&id=1f87dd46&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f87dd46"]])

export default __exports__